import React from 'react'
import { Link } from 'react-router-dom'
import Icon from 'components/patterns/Icon'
import { Dropdown, Menu } from 'antd'
import PropTypes from 'prop-types'
import strings from 'utils/strings'

export default class NestedDropDown extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      expanded: false,
    }
    this.toggle = () =>
      this.setState(({ expanded }) => ({ expanded: !expanded }))
  }

  render() {
    const { expanded } = this.state
    const { list, display, placement } = this.props

    if (!list || list.length === 0) return display

    const menu = (
      <Menu>
        {list.map((item) => {
          if (!item) {
            return <div />
          }
          const { uri, display, children } = item
          return children && children.length > 0 ? (
            <Menu.SubMenu
              key={uri || display}
              title={
                <span>
                  {uri ? (
                    <Link to={uri} target="_blank">
                      {display}
                    </Link>
                  ) : (
                    display
                  )}
                  <span
                    style={{
                      marginLeft: '6px',
                      color: 'rgba(0, 0, 0, 0.25)',
                    }}
                  >
                    {strings.shared_with}
                  </span>
                </span>
              }
            >
              {children.map(({ display, uri }) => (
                <Menu.Item key={uri || display}>
                  {uri ? (
                    <Link to={uri} target="_blank">
                      {display}
                    </Link>
                  ) : (
                    display
                  )}
                </Menu.Item>
              ))}
            </Menu.SubMenu>
          ) : (
            <Menu.Item key={uri || display}>
              {uri ? <Link to={uri}>{display}</Link> : display}
            </Menu.Item>
          )
        })}
      </Menu>
    )

    return (
      <Dropdown
        placement={placement}
        trigger={['hover']}
        onVisibleChange={this.toggle}
        onBlur={this.toggle}
        overlay={menu}
      >
        <span className="ant-dropdown-link">
          <span style={{ marginRight: '6px' }}>{display}</span>
          {list.length > 0 && (
            <Icon icon={expanded ? 'FaChevronUp' : 'FaChevronDown'} />
          )}
        </span>
      </Dropdown>
    )
  }
}

NestedDropDown.defaultProps = {
  list: [],
  placement: 'bottomRight',
}

NestedDropDown.propTypes = {
  list: PropTypes.array,

  display: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  placement: PropTypes.oneOf([
    'topLeft',
    'topCenter',
    'topRight',
    'bottomLeft',
    'bottomCenter',
    'bottomRight',
  ]),
}
